import { render, staticRenderFns } from "./video.vue?vue&type=template&id=72f7de19&scoped=true&lang=pug&"
import script from "./video.vue?vue&type=script&lang=js&"
export * from "./video.vue?vue&type=script&lang=js&"
import style0 from "./video.vue?vue&type=style&index=0&id=72f7de19&prod&lang=sass&"
import style1 from "./video.vue?vue&type=style&index=1&id=72f7de19&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f7de19",
  null
  
)

export default component.exports